/*
 *
 * SharingDialog Constants
 *
 */

export const TEAM_TYPE = 'team';
export const ACCOUNT_TYPE = 'account';
